import './user-menu.scss';
import { RootState } from 'types';
import { Dispatch, SetStateAction, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { actions } from 'redux/reducers';
import { Link, useParams } from 'react-router-dom';
import { useClickOutside } from 'hooks/click-outside';

function UserMenu({
    open,
    buttonRef,
    setOpen
}: {
    open: boolean,
    buttonRef: any,
    setOpen: Dispatch<SetStateAction<boolean>>
}) {
    const ref = useRef<any>();
    const params: any = useParams();
    const history = useHistory();
    const dispatch = useDispatch();
    const state = useSelector((state: RootState) => state);
    const user = useSelector((state: RootState) => state.user);

    useClickOutside([ref, buttonRef], () => setOpen(false));

    const logout = () => {
        localStorage.removeItem('AccessToken');
        dispatch(actions.user.set(null));
        history.replace('/');
    }

    return (
        <div className={`user-menu ${open ? 'open' : ''}`} ref={ref}>
            <div className="user-menu-content-header">
                <i className="fal fa-user"></i>
                <p>{state.user?.Name} {state.user?.Surname}</p>
            </div>
            <div className="user-menu-content-body">
                <Link to={`/client/${params.clientId}/dashboard`}>Dashboard</Link>
                {user.IsAdmin === true && (
                    <Link to={`/admin`}>Admin</Link>
                )}
                {state.clients.length > 1 && <Link to="/clients">Clients</Link>}
                <Link title='Manage all active alerts to your email address' to={`/contact/notifications`}>Notification Management</Link>
            </div>

            <button onClick={logout}>Logout</button>
            <h5 style={{ textAlign: 'center', opacity: '0.3', marginTop: '15px' }}>Version: {process.env.REACT_APP_VERSION}</h5>
        </div>
    )
}

export default UserMenu;